import { ArrowRightIcon } from "lucide-react";
import { automaticCellRenderer } from "../data-table/_helpers/cell-renderer";
import { VehicleValuationProjectedMileageIndicator } from "./projected-mileage-indicator";

interface VehicleValuationMileageDisplayProps {
  mileage?: number | null;
  projectedMileage?: number | null;
  targetDate?: Date | string | null;
}

export function VehicleValuationMileageDisplay({
  mileage,
  projectedMileage,
  targetDate,
}: VehicleValuationMileageDisplayProps) {
  const hasProjectedMileage =
    typeof mileage === "number" && typeof projectedMileage === "number" && projectedMileage !== mileage;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span>{automaticCellRenderer(mileage)}</span>
      {hasProjectedMileage ? (
        <>
          <ArrowRightIcon className="text-muted-foreground h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span className="font-medium">{automaticCellRenderer(projectedMileage)}</span>
        </>
      ) : null}
      <VehicleValuationProjectedMileageIndicator
        mileage={mileage}
        projectedMileage={projectedMileage}
        targetDate={targetDate}
      />
    </div>
  );
}
